"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
class Mutex {
    constructor() {
        this._isLocked = false;
        this.acquire = () => __awaiter(this, void 0, void 0, function* () {
            this.lock = new Promise(resolve => {
                this._isLocked = true;
                this.resolveHandler = resolve;
            });
            yield this.lock;
            this._isLocked = false;
        });
        this.wait = () => __awaiter(this, void 0, void 0, function* () {
            yield this.lock;
        });
        this.isLocked = () => {
            return this._isLocked;
        };
        this.release = () => __awaiter(this, void 0, void 0, function* () {
            if (this.resolveHandler) {
                yield this.resolveHandler();
                this.resolveHandler = undefined;
            }
        });
    }
}
exports.default = Mutex;
//# sourceMappingURL=Mutex.js.map